const IMG = '/images/trainers';
const SHARED = '/images/shared';

const page = {
  slug: 'trainers',
  title: 'For Fitness Trainers',
  hero: {
    title: 'For Fitness Trainers',
    image: `${SHARED}/hero-partners.webp`,
  },
  blocks: [
    // One band: photo on the right, both headings and the sign-up form on the left.
    {
      type: 'split',
      image: `${IMG}/trainer.webp`,
      imageAlt: 'An athlete performing a barbell lunge at a squat rack in a gym',
      imageSide: 'right',
      groups: [
        {
          heading: 'Get Your Clients all the Results with Individually-Tailored Meals',
          paragraphs: [
            'Square Fare makes eating right convenient. We create fresh, high quality food from scratch tailored to the individual needs of your clients (macros, allergies and more) and delivered straight to their door. So all the hard work in the gym pays off!',
            'We serve Manhattan, Brooklyn and Long Island City as well as Westchester and Jersey City/Hoboken.',
          ],
        },
        {
          heading: 'Join our Fitness Ambassador Program',
          paragraphs: ['Email us to get started:'],
        },
      ],
      form: {
        formType: 'trainers',
        fields: ['firstName', 'lastName', 'email', 'newsletter', 'workplace', 'message'],
        submitLabel: 'Submit',
      },
    },
    {
      type: 'steps',
      heading: 'How We Work',
      // Matches the legacy "light-bold" theme, hsl(30,32%,90.2%).
      tone: 'warm',
      items: [
        {
          text: 'Your client places their order using your personal discount code.',
          image: `${SHARED}/step-ingredients.webp`,
          imageAlt: 'A display of cherry tomatoes, mushrooms, garlic and various colorful peppers',
        },
        {
          text: 'They then take our quiz so we can work out their nutritional needs.',
          image: `${SHARED}/step-ordering.webp`,
          imageAlt: 'Man placing a food order on his phone with an open laptop in the background',
        },
        {
          text: "Our nutrition team analyzes the ingredients in our chefs recipes using information from the USDA's FoodData Central. We then group ingredients into categories: meat (animal or plant-based), veggies, starch, and sauce. Our chefs then get the weight instructions for each category of ingredients for every dish.",
          image: `${SHARED}/step-portioning.webp`,
          imageAlt: 'Various sized bowls and measuring spoons filled with different grains, legumes, and spices',
        },
        {
          text: "Meals are delivered fresh to your client's home or office each week.",
          image: `${SHARED}/step-delivery.webp`,
          imageAlt: 'Three rectangular glass containers with a healthy meal inside',
        },
      ],
    },
    {
      type: 'quote',
      image: `${SHARED}/emma-harvie.webp`,
      imageAlt: 'Image of Emma Harvie',
      name: 'Emma Harvie, Functional Nutritionist at',
      link: { label: 'Athleats Nutrition', href: 'https://athleatsnutrition.com/' },
      text: "As a nutritionist, it can be difficult if not seemingly impossible to find meal options for my clients that are convenient, flavorful, diverse, affordable AND that meet the client's nutritional needs. Square Fare checks all the boxes and more, and Claire makes the process of improving health and dietary habits a seamless process for both the client and the practitioner! Recommending Square Fare to health-conscious individuals, athletes, busy working professionals and anyone with a passion for good food is a total no-brainer. Thank you, Claire!",
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
